import { Directive, HostListener, Input } from '@angular/core';
import { GoogleAnalyticsReporterService } from '../../services/google-analytics-reporter/google-analytics-reporter.service';

type GAEventFields = [
  string, // category, e.g. 'Form Builder'
  string, // action, e.g. 'Add Field'
  string?, // label, e.g. 'Short Text'
  number?, // value, e.g. 3
];

@Directive({
  selector: '[coreGaEvent]',
  standalone: false,
})
export class GaEventDirective {
  /** Params to pass to GoogleAnalyticsReporterService */
  @Input('coreGaEvent') public eventParams: GAEventFields;

  constructor(private gaService: GoogleAnalyticsReporterService) {}

  /**
   * Report an event using GoogleAnalyticsReporterService on click
   */
  @HostListener('click') public onClick(): void {
    this.reportEvent(this.eventParams);
  }

  /**
   * @param eventFields The array of fields to use for the GA event should match EventParamsArray type
   */
  private reportEvent(eventFields: GAEventFields): void {
    this.gaService.emitEvent(...eventFields);
  }
}
